import React from 'react';
import { makeStyles } from '@mui/styles';
import i18next from 'i18next';

import Typography from '@mui/material/Typography';
import Image from 'next/image';
import { Grid } from '@mui/material';
import Link from './Link';
import Container from '@mui/material/Container';

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: '#071f48',
    color: 'white',
    marginTop: 'auto',
  },
}));

function Copyright() {
  const currentYear = new Date().getFullYear();

  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {i18next.t(
        'footer.copyright',
        'Copyright © {{currentYear}} Doxer Medical Technologies LTD. All rights reserved.',
        { currentYear },
      )}
    </Typography>
  );
}

const Footer = ({}) => {
  const classes = useStyles();
  const len = i18next.language.substring(0, 2);

  return (
    <footer className={classes.root}>
      <Container maxWidth="md">
        <Grid style={{ minHeight: 74 }} container alignItems="center" justifyContent={'space-between'}>
          <Grid item xs={12} sm={12} md={'auto'}>
            <Grid container justifyContent={'space-between'} spacing={3}>
              <Grid item>
                <Link href={`/${len}/terms`}>{i18next.t('footer.menu.terms', 'terms')}</Link>
              </Grid>

              <Grid item>
                <Link href={`/${len}/privacy`}>{i18next.t('footer.menu.privacy', 'privacy policy')}</Link>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={'auto'}>
            <Copyright />
          </Grid>

          <Grid item xs={12} sm={12} md={'auto'}>
            <Grid container spacing={2}>
              <Grid item>
                <a href={'https://www.facebook.com/Doxerio-100613884917440/'} target={'_blank'} rel="noreferrer">
                  <Image
                    unoptimized={true}
                    src={'/social/fb.png'}
                    alt={i18next.t('footer.social.facebook', 'Facebook')}
                    width={24}
                    height={24}
                  />
                </a>
              </Grid>

              <Grid item>
                <a href={'https://www.linkedin.com/company/doxerio'} target={'_blank'} rel="noreferrer">
                  <Image
                    unoptimized={true}
                    src={'/social/in.png'}
                    alt={i18next.t('footer.social.linkedin', 'Linkedin')}
                    width={24}
                    height={24}
                  />
                </a>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </footer>
  );
};

Footer.propTypes = {};

Footer.defaultProps = {};

export default Footer;
